// shared-utils.service.ts
import { Injectable } from "@angular/core";
import { Role } from "../models/role";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class SharedUtilsService {
  private roleCache = new Map<number, Role>();

  constructor(private router: Router) {}

  setRole(privilegeId: number): Role {
    // Return cached role if exists
    if (this.roleCache.has(privilegeId)) {
      return this.roleCache.get(privilegeId)!;
    }

    const role = this.calculateRole(privilegeId);
    this.roleCache.set(privilegeId, role);
    return role;
  }

  // Global navigation function
  goToHome(role: Role): void {
    setTimeout(() => {
      switch (role) {
        case Role.HO:
          this.router.navigate(["/head/home"]);
          break;
        case Role.Branch:
          this.router.navigate(["/branch/home"]);
          break;
        case Role.Customer:
          this.router.navigate(["/cust/home"]);
          break;
        default:
          this.router.navigate(["/cust/home"]); // Default fallback
      }
    });
  }

  private calculateRole(privilegeId: number): Role {
    switch (privilegeId) {
      case 1:
      case 2:
        return Role.HO;

      case 3:
        return Role.Branch;

      case 4:
      case 5:
      case 6:
        return Role.Customer;

      default:
        return Role.Customer;
    }
  }

  // Clear cache if needed
  clearCache(): void {
    this.roleCache.clear();
  }
}
